module.exports = __webpack_public_path__ + "img/icon-69.ae1979b1.svg";